import { type Client, graphql, prefetch } from "@opensea/graphql"
import { FeaturedItemSlideFragment } from "@/components/collection/overview/components/ContentBlockModule/components/FeaturedItemSlide/FeaturedItemSlide.fragment"

export const CollectionBestDealsQuery = graphql(
  `
    query CollectionBestDealsQuery($collectionSlug: String!) {
      collectionBestDeals(collectionSlug: $collectionSlug) {
        ... on Item {
          id
          ...FeaturedItemSlide
        }
      }
    }
  `,
  [FeaturedItemSlideFragment],
)

export const prefetchCollectionBestDealsQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionBestDealsQuery, { collectionSlug })
}
